import { Link } from "react-router-dom";
import BookingButton from "@/components/BookingButton";

export default function CTASection({
  eyebrow = "Let's talk",
  title = "Ready to modernize your database environment?",
  body = "Start with an initial technical discovery discussion. We will follow up with an assessment and a customized proposal tailored to your infrastructure, business goals and project scope.",
}) {
  return (
    <section data-testid="cta-section" className="bg-[var(--dm-navy)] text-white">
      <div className="dm-container dm-section grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="dm-overline text-white/60">{eyebrow}</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight mt-4">{title}</h2>
          <p className="text-white/70 mt-6 max-w-lg leading-relaxed">{body}</p>
        </div>
        <div className="flex flex-col sm:flex-row lg:justify-end gap-3 flex-wrap">
          <BookingButton label="Request Technical Assessment" meetingType="consultation" variant="primary" testId="cta-request-assessment" />
          <BookingButton label="Schedule Discovery Call" meetingType="discovery" variant="ghost" testId="cta-book-discovery" />
          <Link to="/contact" data-testid="cta-contact-link" className="dm-btn-ghost">Talk to a Specialist</Link>
        </div>
      </div>
    </section>
  );
}
